import React, {Component} from 'react';
import {connect} from 'react-redux';
import ReactDOMServer from 'react-dom/server';
import PropTypes from 'prop-types';
import store from 'store';

import Marker from '../../../assets/images/Marker.png';
import MarkerHover from '../../../assets/images/MarkerHover.png';
import MarkerSuccess from '../../../assets/images/MarkerSuccess.png';
import MarkerHoverSuccess from '../../../assets/images/MarkerHoverSuccess.png';

import PolyUtil from "../../../util/PolyUtil";
import {displayModal, updateModal} from "../../../store/actions/display";
import {Button} from "reactstrap";
import {Link} from "react-router";
import CompactListing from "../../../containers/listings/CompactListing";
import {handleAddToInterestList, handleRemoveFromInterestList} from "../../../containers/tenant/actions/tenant";
import {AsyncButton} from "../../controls/buttons/AsyncButton";

/*global google*/

/*eslint no-undef: "error"*/

class ListingStreetMap extends Component {
    state = {
        markers: [],
    };

    componentDidMount() {
        this.initializeMap();
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.map !== null) {
            this.updateMarkers(nextProps);
        }
    }

    createListingModal = (listing, props) => {
        const {interestList, appliedListings, _handleAddToInterestList, _handleRemoveFromInterestList} = props;
        const rent = PolyUtil.formatUSD(listing.rent);
        const address = PolyUtil.getPropertyStreetAddress(listing.prop);

        const interested = !!interestList.find((prop) => {
            return prop.id === listing.prop.id;
        });

        const applied = !!appliedListings.find((list) => {
            return list.apply_key === listing.apply_key;
        });

        return {
            id: 'map_listing_modal',
            header: (
                <div>
                    <strong>{address} {listing.prop.identifier && "(" + listing.prop.identifier + ")"}</strong> - {rent}/month
                    {
                        interested && (
                            <div>
                                <small className="text-success"><i className="fa fa-star"/> In your saved properties</small>
                            </div>
                        )
                    }
                    {
                        applied && (
                            <div>
                                <small className="text-success"><i className="fa fa-check"/> Applied to this listing</small>
                            </div>
                        )
                    }
                </div>
            ),
            body: (<CompactListing listing={listing}/>),
            footer: (
                <div className="d-flex w-100 justify-content-center">
                    {
                        interested ? (
                            <AsyncButton noComplete
                                         style={{width: '15rem'}}
                                         task={() => _handleRemoveFromInterestList(listing, _handleAddToInterestList, _handleRemoveFromInterestList, applied, interested)}
                                         color="danger" className="mr-1" outline>
                                Remove from Saved Properties
                            </AsyncButton>
                        ) : (
                            <AsyncButton noComplete
                                         style={{width: '15rem'}}
                                         task={() => _handleAddToInterestList(listing, _handleAddToInterestList, _handleRemoveFromInterestList)}
                                         color="info" className="mr-1" outline>Save for
                                Later</AsyncButton>
                        )
                    }
                    <Button color="info" outline style={{width: '15rem'}} tag={Link} to={"/listings/" + listing.apply_key} onClick={() => store.set('prev', 'explore')}>View Listing</Button>
                </div>
            )
        };
    };

    displayListingModal = (listing) => {
        this.props._displayModal(this.createListingModal(listing, this.props));
    };

    updateMarkers = (props) => {
        const markers = this.state.markers;
        for (let i = 0; i < markers.length; i++) {

            markers[i].setVisible(Object.keys(props.listings).includes(markers[i].id));

            if (props.interestList.find((prop) => {return prop.active_listing.apply_key === markers[i].id;})) {
                markers[i].setIcon(MarkerSuccess);
                markers[i].interested = true;
            } else {
                markers[i].setIcon(Marker);
                markers[i].interested = false;
            }
        }

        this.setState({markers: markers});
    };

    initializeMap = () => {
        const {listings, interestList, location, zoom} = this.props;
        const _displayModal = this.props._displayModal;

        let map = new google.maps.Map(this.refs.mapContainer, {
            center: location,
            scrollwheel: false,
            mapTypeControl: false,
            zoom: zoom || 13,
        });

        let markers = [];
        for (let key in listings) {
            if (listings.hasOwnProperty(key)) {
                const listing = listings[key];
                const rent = PolyUtil.formatUSD(listing.rent);
                const address = PolyUtil.getPropertyStreetAddress(listing.prop);

                const interested = !!interestList.find((prop) => {
                    return prop.id === listing.prop.id;
                });

                let infowindow = new google.maps.InfoWindow({
                    content: ReactDOMServer.renderToStaticMarkup((
                        <div>
                            <p><strong>{address}</strong> - {rent}</p>
                        </div>
                    ))
                });

                let marker = new google.maps.Marker({
                    position: listing.prop.address_details.geometry.location,
                    map: map,
                    // animation: google.maps.Animation.DROP,
                    icon: interested ? MarkerSuccess : Marker,
                    id: listing.apply_key,
                    interested: interested
                });

                marker.addListener('click', () => {
                    map.panTo(listing.prop.address_details.geometry.location);
                    this.displayListingModal(listing);
                });

                marker.addListener('mouseover', function () {
                    marker.setIcon(marker.interested ? MarkerHoverSuccess : MarkerHover);
                    infowindow.open(map, marker);
                });

                marker.addListener('mouseout', function () {
                    marker.setIcon(marker.interested ? MarkerSuccess : Marker);
                    infowindow.close();
                });

                markers.push(marker);
            }
        }

        this.setState({markers: markers});
    };

    render() {
        return (
            <div style={{height: this.props.height, width: this.props.width, ...this.props.style}} ref="mapContainer"/>
        );
    }
}

ListingStreetMap.propTypes = {
    location: PropTypes.object,
    height: PropTypes.string,
    width: PropTypes.string,
    zoom: PropTypes.number,
    style: PropTypes.object,
    listings: PropTypes.object,
};

ListingStreetMap.defaultProps = {
    width: '100%',
    height: '100%'
};

const mapStateToProps = (state) => ({
    interestList: state.tenant.interest_list,
    appliedListings: state.tenant.roommate_group.applied_listings,
});

const mapDispatchToProps = (dispatch, props) => ({
    _displayModal(modalData) {
        return dispatch(displayModal(modalData));
    },
    _handleAddToInterestList(listing, handleAdd, handleRemove, applied) {
        return dispatch(handleAddToInterestList(listing.prop))
            .then(() => {

                return dispatch(updateModal({
                    id: 'map_listing_modal',
                    header: (
                        <div>
                            <strong>{PolyUtil.getPropertyStreetAddress(listing.prop)} {listing.prop.identifier && "(" + listing.prop.identifier + ")"}</strong> - {PolyUtil.formatUSD(listing.rent)}/month
                            <div>
                                <small className="text-success"><i className="fa fa-star"/> In your saved properties</small>
                            </div>
                            {
                                applied && (
                                    <div>
                                        <small className="text-success"><i className="fa fa-check"/> Applied to this listing</small>
                                    </div>
                                )
                            }
                        </div>
                    ),
                    footer: (
                        <div className="d-flex w-100 justify-content-center">
                            <AsyncButton noComplete
                                         style={{width: '15rem'}}
                                         task={() => handleRemove(listing, handleAdd, handleRemove, applied)} color="danger" className="mr-1" outline>
                                Remove from Saved Properties
                            </AsyncButton>
                            <Button color="info" outline style={{width: '15rem'}} tag={Link} to={"/listings/" + listing.apply_key} onClick={() => store.set('prev', 'explore')}>View Listing</Button>
                        </div>
                    )

                }));
            });
    },
    _handleRemoveFromInterestList(listing, handleAdd, handleRemove, applied) {
        return dispatch(handleRemoveFromInterestList(listing.prop))
            .then(() => {
                return dispatch(updateModal({
                    id: 'map_listing_modal',
                    header: (
                        <div>
                            <strong>{PolyUtil.getPropertyStreetAddress(listing.prop)} {listing.prop.identifier && "(" + listing.prop.identifier + ")"}</strong> - {PolyUtil.formatUSD(listing.rent)}/month
                            {
                                applied && (
                                    <div>
                                        <small className="text-success"><i className="fa fa-check"/> Applied to this listing</small>
                                    </div>
                                )
                            }
                        </div>
                    ),
                    footer: (
                        <div className="d-flex w-100 justify-content-center">
                            <AsyncButton noComplete style={{width: '15rem'}} task={() => handleAdd(listing, handleAdd, handleRemove, applied)} color="info" className="mr-1" outline>Save for
                                Later</AsyncButton>
                            <Button color="info" outline style={{width: '15rem'}} tag={Link} to={"/listings/" + listing.apply_key} onClick={() => store.set('prev', 'explore')}>View Listing</Button>
                        </div>
                    )

                }));
            });
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(ListingStreetMap);


// WEBPACK FOOTER //
// ./src/components/media/maps/ListingStreetMap.js